import { ReactElement } from 'react';
import { SpinProps } from 'antd';
import { SSpin } from './Spin.style';

export const Spin = ({ rootClassName, ...restProps }: SpinProps): ReactElement => (
  <SSpin rootClassName={['custom-ant-spin', rootClassName].join(' ')} {...restProps} />
);
